export const SET_COMPONENT_LIST = 'SET_COMPONENT_LIST'
export const SET_COMPONENT_DETAIL = 'SET_COMPONENT_DETAIL'

export const UPDATE_COMPONENT_ITEM = 'UPDATE_COMPONENT_ITEM'
export const SET_VERSION_LIST = 'SET_VERSION_LIST'
export const DELETE_VERSION = 'DELETE_VERSION'

export const SET_BRANCH_TAG_INFO = 'SET_BRANCH_TAG_INFO'

export const SET_PACKAGE_LIST = 'SET_PACKAGE_LIST'
